import styles from "./department-category.module.scss";
import styleDepartment from "../departments.module.scss";
import cl from "classnames";
import { observer } from "mobx-react-lite";
import {
  Checkbox,
  IconClose,
  ImagePortrait,
  PageContainer,
  PaginationButtons,
  RatingStars,
  Select,
  Slider,
  ValueTag,
} from "@touche-lts/panel-ui/dist";
import { useRootStore } from "mobx-stores/store-provider";
import { useEffect } from "react";
import { useParams } from "react-router";
import AvatarEditor from "react-avatar-editor";
import {
  CategoriesSortBy,
  Department,
  DepartmentCategory,
  filterRatingCategories,
} from "models/departments";

const DepartmentCategoryPageComponent = () => {
  const defaultImageSrc =
      "https://st2.depositphotos.com/4403291/7418/v/600/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    {
      departmentsStore: {
        allDepartments,
        allCategories,
        getAllCategories,
        paginationInfo,
        onPageSelect,
        setCategoryId,
        pageProductCategory,
        getCategoryFiltersById,
        getCategoryFilters,
        getFilteredProducts,
        handleCheckboxClickStore,
        handleCheckboxClickManufacturer,
        handleCheckboxClickSubcategory,
        handleExpandTypes,
        handleCheckboxClickTypes,
        CategotySortBy,
        selectedCategorySortingSelected,
        setCategorySorting,
        removeFiterStores,
        categoryStoresSelected,
        clearAllCategoryFilters,
        changePrice,
        infoRatingFilter,
        setRatingFilterDirection,
        setRatingFilterRating,
      },
      routingStore: { push },
    } = useRootStore(),
    { departmentId, categoryId } = useParams<{
      departmentId: string;
      categoryId: string;
    }>(),
    handleDepartmentCover = (): Department => {
      return allDepartments.find(
        (department: Department) => department?.id === Number(departmentId),
      );
    },
    handleCategoryCover = (): DepartmentCategory => {
      return allCategories.find(
        (category: DepartmentCategory) => category?.id === Number(categoryId),
      );
    };

  setCategoryId(Number(categoryId));

  useEffect(() => {
    if (departmentId) {
      getAllCategories(Number(departmentId));
      getCategoryFiltersById(Number(categoryId));
      getFilteredProducts();
    }
  }, [
    departmentId,
    getCategoryFiltersById,
    getFilteredProducts,
    getAllCategories,
    categoryId,
  ]);

  return (
    <PageContainer className={cl("container", styles.scrollable)}>
      <div className={cl(styleDepartment.departmentCoverImage, "mb-4")}>
        <AvatarEditor
          image={handleCategoryCover()?.backgroundCrop?.url}
          width={1200}
          height={263}
          border={0}
          scale={handleCategoryCover()?.backgroundCrop?.squareWidth}
          position={{
            x: handleCategoryCover()?.backgroundCrop?.squareX,
            y: handleCategoryCover()?.backgroundCrop?.squareY,
          }}
          rotate={0}
        />
        <p>
          <span onClick={() => push(`/departments/${departmentId}`)}>
            {handleDepartmentCover()?.name + " > "}
          </span>
          <span>{handleCategoryCover()?.name}</span>
        </p>
      </div>
      <div className={cl("container", styles.storePageContainer)}>
        <div className="row">
          <div className="col-lg-3">
            <div className={styles.filterContainer}>
              <h2>Product type</h2>
              {getCategoryFilters?.subcategories?.map(
                (subcategory: any, index) => {
                  return (
                    <div>
                      <div>
                        <Checkbox
                          isChecked={subcategory?.checked}
                          onClick={() => handleCheckboxClickSubcategory(index)}
                          style={{ marginRight: 10 }}
                        />
                        <p>{subcategory?.name}</p>
                        {!subcategory?.expanded && (
                          <span
                            className={styles.attributePlus}
                            onClick={() => handleExpandTypes(index)}
                          >
                            +
                          </span>
                        )}
                        {subcategory?.expanded && (
                          <span
                            className={styles.attributeMinus}
                            onClick={() => handleExpandTypes(index)}
                          >
                            -
                          </span>
                        )}
                      </div>
                      {subcategory?.expanded &&
                        subcategory?.types.map((type: any, typeIndex) => {
                          return (
                            <div className={styles.subCatCheckbox}>
                              <Checkbox
                                isChecked={type?.checked}
                                onClick={() =>
                                  handleCheckboxClickTypes(index, typeIndex)
                                }
                              />{" "}
                              <span>{type?.name}</span>
                            </div>
                          );
                        })}
                    </div>
                  );
                },
              )}
              <hr />
              <h2>Customer rating</h2>
              <div className="d-flex">
                <div className="d-flex flex-column">
                  <div className="d-flex">
                    <RatingStars rating={infoRatingFilter.rating} />
                    <span className={styles.ratingValueSelected}>
                      {infoRatingFilter.rating}
                    </span>
                  </div>
                  <input
                    type="range"
                    value={infoRatingFilter.rating}
                    min="0"
                    max="5"
                    step={0.01}
                    className="mt-2"
                    onChange={(ev) =>
                      setRatingFilterRating(Number(ev.target.value))
                    }
                  />
                </div>
                <select
                  onChange={(ev) => setRatingFilterDirection(ev.target.value)}
                >
                  <option value={filterRatingCategories.UP}>
                    {filterRatingCategories.UP}
                  </option>
                  <option value={filterRatingCategories.DOWN}>
                    {filterRatingCategories.DOWN}
                  </option>
                </select>
              </div>
              <hr />
              <h2>Store</h2>
              {getCategoryFilters?.stores?.map((store: any, index) => {
                return (
                  <div>
                    <div>
                      <Checkbox
                        isChecked={store?.checked}
                        onClick={() => handleCheckboxClickStore(index)}
                        style={{ marginRight: 10 }}
                      />
                      <p>{store?.name}</p>
                    </div>
                  </div>
                );
              })}
              <hr />
              <h2>Manufacturers</h2>
              {getCategoryFilters?.manufacturers?.map(
                (manufacturer: any, index) => {
                  return (
                    <div>
                      <div>
                        <Checkbox
                          isChecked={manufacturer?.checked}
                          onClick={() => handleCheckboxClickManufacturer(index)}
                          style={{ marginRight: 10 }}
                        />
                        <p>{manufacturer?.name}</p>
                      </div>
                    </div>
                  );
                },
              )}
              <hr />
              <Slider
                colorPreset="dark"
                label="Price"
                value={[
                  getCategoryFilters?.selectedPriceMin,
                  getCategoryFilters?.selectedPriceMax,
                ]}
                className={styles.priceProductRange}
                min={getCategoryFilters?.priceMin}
                max={getCategoryFilters?.priceMax}
                onChange={(price) => changePrice(price)}
              />
              <hr />
              <p onClick={() => clearAllCategoryFilters()}>
                <IconClose onClick={() => clearAllCategoryFilters()} />
                Clear all filters
              </p>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="row">
              <div className="col-lg-8">
                <p className={styles.sortingElementsCount}>
                  {pageProductCategory?.totalElements} results
                </p>
              </div>
              <div className="col-lg-4">
                <div className={styles.selectStore}>
                  <p className={styles.storeSortBy}>Sort by</p>
                  <Select<CategoriesSortBy>
                    colorPreset="dark"
                    options={CategotySortBy}
                    noNoneOption
                    value={selectedCategorySortingSelected}
                    placeholder="Actions"
                    className={styles.selectRootClassName}
                    onChange={(type) => setCategorySorting(type)}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column">
              {!!categoryStoresSelected.length && (
                <div className={styles.valueTagsFilter}>
                  {categoryStoresSelected?.map((store: any, index) => {
                    return (
                      <div className={styles.valueSingleTag}>
                        <ValueTag
                          key={index}
                          valueName={store?.name}
                          removable={true}
                          onRemove={() => removeFiterStores(store?.id)}
                        />
                      </div>
                    );
                  })}
                  <div className={styles.valueTagCloseAll}>
                    <IconClose onClick={() => clearAllCategoryFilters()} />
                  </div>
                </div>
              )}
            </div>
            <div className={styles.storesContainer}>
              {pageProductCategory?.content?.map((product) => {
                return (
                  <div
                    className={styles.productInfo}
                    onClick={() => push(`/product/${product.id}`)}
                  >
                    <div className={styles.productInfoDetails}>
                      <ImagePortrait
                        width={176}
                        height={176}
                        src={
                          !!product?.image
                            ? product?.image?.url
                            : defaultImageSrc
                        }
                      />
                      <div className={styles.productInfoDetailsText}>
                        <h2>{product.name}</h2>
                        <div className={styles.price}>${product.price}</div>
                        <RatingStars
                          rating={product?.rating}
                          reviewsCnt={product?.reviewsCnt}
                        />
                        <h3>{product?.storeName}</h3>
                        <small>Add to cart</small>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <PaginationButtons
              colorPreset="dark"
              alwaysShow
              {...paginationInfo}
              onPageSelect={onPageSelect}
            />
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

const DepartmentCategoryPage = observer(DepartmentCategoryPageComponent);
export { DepartmentCategoryPage };
